module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp3_3016.02d7f701.png";